import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      isPc:true,
      mapKey:"WlycVhHWyC5gA5vt4FgFPYu2TGnDIgxz",
    //   productList:[ //全局商品信息
    //     {
    //       id:1,
    //       title:"热轧带钢生产线",
    //       content:"",
    //       url:require('@/assets/images/product_01_01.jpeg'),
    //       type:1
    //      },  {
    //       id:2,
    //       title:"中厚板矫直机智能控制系统",
    //       content:"",
    //       url:require('@/assets/images/product_01_02.jpeg'),
    //       type:1
    //      }, {
    //       id:3,
    //       title:"无缝钢管连轧智能生产过程",
    //       content:"",
    //       url:require('@/assets/images/product_01_03.jpeg'),
    //       type:1
    //      } ,{
    //       id:4,
    //       title:"棒线材生产线",
    //       content:"",
    //       url:require('@/assets/images/product_01_04.jpeg'),
    //       type:1
    //      } ,
    //      {
    //       id:6,
    //       title:"IEAM资产云管理系统",
    //       content:"",
    //       url:require('@/assets/images/product_02_01.jpeg'),
    //       type:2
    //      },{
    //       id:7,
    //       title:"三维建模与虚拟",
    //       content:"",
    //       url:require('@/assets/images/product_02_02.jpeg'),
    //       type:2
    //      },{
    //       id:8,
    //       title:"点巡检系统（JYSmart）",
    //       content:"",
    //       url:require('@/assets/images/product_02_03.jpeg'),
    //       type:2
    //      },
    //      {
    //       id:9,
    //       title:"设备管理系统(EAM)",
    //       content:"",
    //       url:require('@/assets/images/product_02_04.png'),
    //       type:2
    //      },
    //      {
    //       id:10,
    //       title:"大数据采集及分析平台",
    //       content:"",
    //       url:require('@/assets/images/product_02_05.jpeg'),
    //       type:2
    //      },
    //      {
    //       id:11,
    //       title:"MES智能制造执行系统",
    //       content:"",
    //       url:require('@/assets/images/product_02_06.jpeg'),
    //       type:2
    //      },
    //      {
    //       id:13,
    //       title:"机器手臂代人取物",
    //       content:"",
    //       url:require('@/assets/images/product_03_01.jpeg'),
    //       type:3
    //      },
    //      {
    //       id:14,
    //       title:"AI机器视觉",
    //       content:"",
    //       url:require('@/assets/images/scene3.jpeg'),
    //       type:3
    //      },
    //       {
    //       id:15,
    //       title:"机器人喷标",
    //       content:"",
    //       url:require('@/assets/images/scene2.jpeg'),
    //       type:3
    //      },
    //      {
    //       id:16,
    //       title:"机器人挂牌",
    //       content:"",
    //       url:require('@/assets/images/product_03_04.jpg'),
    //       type:3
    //      },
    //      {
    //       id:17,
    //       title:"钢管平直度检测",
    //       content:"",
    //       url:require('@/assets/images/product_03_05.jpg'),
    //       type:3
    //      },  {
    //       id:18,
    //       title:"物料识别",
    //       content:"",
    //       url:require('@/assets/images/product_03_06.jpg'),
    //       type:3
    //      }
    //  ],
     productNewList:[ //全局商品信息(新版)
     {
       id:1,
       title:"管端打磨及尺寸检测",
       content:"",
       url:require('@/assets/images/news02.jpg'),
       type:1
      },  {
       id:2,
       title:"平直度检测",
       content:"",
       url:require('@/assets/images/product_02_01.jpg'),
       type:1
      }, {
       id:3,
       title:"内表缺陷检测",
       content:"",
       url:require('@/assets/images/product_01_03.jpg'),
       type:1
      } ,
      {
       id:5,
       title:"机器人挂牌",
       content:"",
       url:require('@/assets/images/product_03_04.jpg'),
       type:2
      },
      {
       id:6,
       title:"物料识别",
       content:"",
       url:require('@/assets/images/product_03_06.jpg'),
       type:2
      },
      {
        id:7,
        title:"智能跟踪软件",
        content:"",
        url:require('@/assets/images/product_02_07.jpg'),
        type:2
       } 
  ],
     newsList:[{
      id:1,
      title:"热烈庆祝全国钢管协会参会展示取得圆满成功",
      content:"由中国金属学会轧钢分会主办、钢研纳克检测技术股份有限公司协办的 “2022 年全国钢管生产技术交流会”于 2022年11月10日在四川成都召开。会议围绕“创新引领•结构优化•智能升级•高质发展”的主题，邀请业内专家、学者作专题报告，开展技术交流。",
      time:"2022-11-10",
      url:require('@/assets/images/news01.jpg')
       },
       {
      id:2,     
      title:"行业首台套无缝钢管智能工厂项目有序推进",
      content:" 承德建龙是集烧结、球团、炼铁、炼钢、轧钢、制氧、水泥于一体的特种钢联合企业，是承德市五大支柱企业、是河北省优势企业、河北省重点保护企业、河北省百强工业企业、省级农行AAA级信用客户，承德市出口创汇企业。",
      time:"2022-10-06",
      url:require('@/assets/images/news_02.jpg')
       },
       {
      id:3,     
      title:"全力确保湖南华菱集团人工智能项目稳步推进",
      content:"湖南华菱钢铁集团有限责任公司（以下简称华菱集团）是1997年底由湖南三大钢铁企业--湘钢、涟钢、衡钢联合组建的大型企业集团，作为省属国有企业，由省国资委授权经营。",
      time:"2022-05-08",
      url:require('@/assets/images/news03.jpg')
       },
       {
        id:4,    
       title:"精益人连夜奋战全力确保江阴兴澄大棒项目通过验收",
       content:"江阴兴澄特种钢铁有限公司隶属中信特钢集团，由香港中信泰富有限公司于一九九三年投资成立，现为国家火炬计划重点高新技术企业、中国特钢企业协会会长单位、中国首家4A级国家标准化良好行为企业、江苏省十佳节能减排示范企业。",
       time:"2022-06-06",
       url:require('@/assets/images/news04.jpg')
        }
      //  {
      // id:5,  
      // title:"春风正好,来自长广溪公园里的欢声笑语",
      // content:"公司附近的长广溪公园里一花一草一木，清风徐徐，好不舒服，团建，再适合不过了，小伙伴儿们席地而坐，一起聊聊生活，简单舒适珍惜，感恩，努力，坚持，成长，欢乐，美好总会如约而至。",
      // time:"2022-04-20",
      // url:require('@/assets/images/newsdetail_05_01.jpg')
      //  },
      //  {
      // id:6,  
      // title:"员工父母生日礼金",
      // content:"江苏精益也会在每一位员工父母过生日前夕，为父母们寄去生日礼金和感谢信，送上公司的祝福。",
      // time:"2022-02-20",
      // url:require('@/assets/images/newsdetail_06_01.jpg')
      //  },
      //  {
      //  id:7,  
      //  title:"金秋十月，长广溪户外团建",
      //  content:"金秋十月，秋高气爽的季节，一阵微风吹过，一片片叶子落下来，在空中飘飘悠悠，忽而高忽而低，像在空中轻歌曼舞，我们趁着这迷人的时光，来到了长广溪举行公司团建。",
      //  time:"2021-10-16",
      //  url:require('@/assets/images/news07.jpg')
      //  },
      //  {
      //  id:8,  
      // title:"儿童福利院特别的生日",
      // content:"每年“江苏精益”都会派代表去无锡市儿童福利院看望孩子们，“精益智控”一行五人，带着提前准备好的捐赠物资到了无锡市儿童福利院。",
      // time:"2021-10-06",
      // url:require('@/assets/images/news08.jpg')
      //  },
      // {
      //  id:9,  
      // title:"关于“是否需要重新启动顺风车”的辩论",
      // content:"“精益人”每周会组织一次团体活动而这一次，我们进行的是一场关于“是否需要重新启动顺风车”的辩论",
      // time:"2021-07-06",
      // url:require('@/assets/images/news09.jpg')
      //  },    
      //  {
      //  id:10,  
      //  title:"啦啦啦，九月团建之山庄小聚",
      //  content:"九月的天空，格外地高；九月的天气，格外地爽；九月的风儿，格外地柔，九月的大地绿意依然，一大片一大片放肆地铺向远方尽头。九月，”精益人”在山庄又有了一场相约。",
      //  time:"2021-09-06",
      //  url:require('@/assets/images/news10.jpg')
      //  }
     ],
     personCareList:[
      {
        id:6,  
        title:"员工父母生日礼金",
        content:"江苏精益也会在每一位员工父母过生日前夕，为父母们寄去生日礼金和感谢信，送上公司的祝福。",
        time:"2022-02-20",
        url:require('@/assets/images/newsdetail_06_01.jpg')
         },
         {
          id:8,  
         title:"儿童福利院特别的生日",
         content:"每年“江苏精益”都会派代表去无锡市儿童福利院看望孩子们，“精益智控”一行五人，带着提前准备好的捐赠物资到了无锡市儿童福利院。",
         time:"2021-10-06",
         url:require('@/assets/images/news08.jpg')
          }
     ]
  },
  getters: {
  },
  mutations: {
    changePcState(state,val){ 
        state.isPc=val;
    }
  },
  actions: {
  },
  modules: {
  }
})
